@import '../../styles/modals.css';
@import '../../styles/form.css';
@import '../../styles/modal-loading-overlay.css';
@import '../../styles/buttons.css';

:host .tambr-modal-logout {
  justify-content: end;
}